var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('funds-page',{attrs:{"is-iam-k-i":_vm.getUSER.qualifiedInvestor,"funds-list":this.getFundsList},on:{"onPush":_vm.goPush,"buy":_vm.goBuy}})}
var staticRenderFns = []

export { render, staticRenderFns }